import React from 'react';
import { GALLERY_CONSTS } from 'pro-gallery';
import { useWindowResize } from '../hooks/useWindowResize';
import { useFullscreenLoader } from '../hooks/useFullscreenLoader';
import { extendNestedOptionsToIncludeOldAndNew, } from 'pro-gallery-lib';
import optionsConverter from '../../proGalleryOptionsBuilder';
export default function FullscreenWrapper(props) {
    var container = useWindowResize()[0];
    var _a = useFullscreenLoader(), isFullscreenLoaded = _a[0], FullscreenElement = _a[1];
    var fullscreenOptions = optionsConverter(props.options).fullscreenOptions;
    var migratedOptions = extendNestedOptionsToIncludeOldAndNew(fullscreenOptions);
    var eventsListener = function (eventName) {
        switch (eventName) {
            case 'CLOSE_FULLSCREEN':
                props.setFullscreenIdx(-1);
                break;
            default:
                break;
        }
    };
    return (isFullscreenLoaded ?
        React.createElement("div", { className: "pro-fullscreen-wrapper" },
            React.createElement(FullscreenElement, { forceProGallerySlider: true, items: props.items, initialIdx: props.fullscreenIdx, totalItemsCount: props.items.length, container: container, locale: props.locale, 
                // homeGalleryPageUrl={pageUrl}
                styles: migratedOptions, isAccessible: props.isAccessible, galleryId: props.galleryId, viewMode: props.viewMode, noFollowForSEO: props.noFollowForSEO, eventsListener: eventsListener, itemsLoveData: [], deviceType: props.deviceType, isPreview: props.viewMode === GALLERY_CONSTS.viewMode.PREVIEW, animationDuration: props.animationDuration, shouldUseNewSocialSharePopup: false, createMediaUrl: props.createMediaUrl, staticMediaUrls: props.staticMediaUrls, backgroundFilterElementSelector: props.backgroundFilterElementSelector })) : null);
}
//# sourceMappingURL=fullscreenWrapper.js.map